import Zones from '../sections/Zones';

import ZonesHeroSection from '../zones/ZonesHeroSection';
import type { WebSection } from '@wbk/contentful/api';

type Props = {
  section: WebSection;
};

const ZonesSections = ({ section }: Props) => {
  switch (section.renderType) {
    case 'hero':
      return <ZonesHeroSection section={section} />;

    default:
      break;
  }

  const type = section.contentCollection?.items?.[0]?.__typename;

  switch (type) {
    case 'Zone':
      return <Zones section={section} className='!mt-0' />;

    default:
      return <></>;
  }
};

export default ZonesSections;
